import React from 'react'
import { Box, Text, Button } from 'pcln-design-system'

type MoreCityType = {
  handleCallback: () => void
  city: string
}

const AmbiguousCityLink = ({ handleCallback, city }: MoreCityType) => {
  return (
    <Box py={[2, null, 1]}>
      <Button
        type="button"
        variation="link"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault()
          handleCallback()
        }}
      >
        <Text fontSize={0}>Looking for a different {city}?</Text>
      </Button>
    </Box>
  )
}

export default AmbiguousCityLink
